import styled from 'styled-components';
import {dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';

export const wrap = styled.div<{$initial?: boolean}>`
    ${dFlexColumnCenter};
    flex: none;
    gap: var(--space-sm);
    padding: ${({$initial}) => ($initial ? 'var(--space-xl) var(--space-lg)' : 'var(--space-md) var(--space-lg)')};
    text-align: center;
`;

export const text = styled.p`
    font-size: var(--font-size-body-small);
    color: var(--color-text-subtle);
`;
